import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './footerStyles.scss';

const Footer = () => {
    useEffect(() => {
        const script = document.createElement('script');

        script.src = "https://portal.voiceworx.ai/chatbot/Script/bdf1336b-9e0f-4e15-a519-4cc825d5decf";
        script.async = true;
        script.charset = "UTF-8";
        script.setAttribute("crossorigin", "*");

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        }
    }, []);
    const navigate = useNavigate();

    const handleSignOut = () => {
        // Call the Flask backend to sign out
        fetch('/signout', {
            method: 'GET',
            credentials: 'include'  // Ensure cookies are sent with the request
        })
        .then(response => {
            // Clear the local storage
            localStorage.clear();
            // Redirect to the home page
            navigate('/');
        })
        .catch(error => {
            console.error('Error signing out:', error);   
        });
    };

    const parentUrl = React.useMemo(() => {
        const currentUrl = new URL(window.location.href);
        currentUrl.pathname = currentUrl.pathname.substring(0, currentUrl.pathname.lastIndexOf('/'));
        return currentUrl.toString();
    }, []);

    return (
        <div id="footerContainer">
            <div id="footerContent">
                <Link to="/fulfill" className='footerLink'>Help</Link>
                <a href="/misc/privacy-policy" target="_blank" className='footerLink'>Privacy Policy</a>
                <a href="/misc/tos" target="_blank" className='footerLink'>Terms Of Service</a>
                <a href="/about-aggie" target="_blank" className='footerLink'>v0.1</a>
                <a href="/" className='footerLink' onClick={(event) => {
                    event.preventDefault();
                    handleSignOut();
                }}>Sign Out</a>
            </div>
        </div>
    );
}

export default Footer;